export type { IconTypes } from './Icon.Types'
export { StyledIcon } from './Icon.Styled'
export { default } from './Icon'
